"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDrawerOpen = exports.reduceDrawerOpen = exports.initialState = exports.getDrawerOpen = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
const initialState = exports.initialState = {
  drawerOpen: false
};
const setDrawerOpen = exports.setDrawerOpen = (0, _toolkit.createAction)("setDrawerOpen");
const reduceDrawerOpen = function (state, _ref) {
  let {
    payload
  } = _ref;
  return {
    ...state,
    drawerOpen: payload
  };
};
exports.reduceDrawerOpen = reduceDrawerOpen;
const getDrawerOpen = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return state.drawerOpen;
};
exports.getDrawerOpen = getDrawerOpen;
var _default = exports.default = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(setDrawerOpen, function (state, action) {
    state.drawerOpen = action.payload.drawerOpen;
  });
}); // export default createReducer(initialState, {
//   [setDrawerOpen]: reduceDrawerOpen,
// });